<template>
    <el-card class="box-card">
        <div style="margin-bottom: 10px;">
            <span>地图标点：</span>
            <el-cascader
                v-model="mapSelectId"
                :options="bigWorldData"
                :show-all-levels="false"
                filterable
                placeholder='请选择'
                @change="getMapSelectId">
            </el-cascader>
            <!--<el-select v-model="mapSelectId" filterable @change="getMapSelectId">-->
                <!--<el-option v-for="item in mapData" :key="item.id" :label="(item.id ) +'-' + $t(item.name)" :value="item.id" :disabled="item.floor !== bigWorldFloor">-->
                <!--</el-option>-->
            <!--</el-select>-->
            <el-button @click="mapShow = !mapShow">{{mapShow?'隐藏':'展开'}}</el-button>
        </div>

        <div class="map" id="mapDiv" style="overflow: scroll" v-show="mapShow">
            <img
                id="map"
                :src="require('../../assets/icons/map'+bigWorldFloor+'.jpg')"
                :style="{width:bigWorldFloor == 1?'2500px':bigWorldFloor == 2?'3000px':bigWorldFloor == 7?'2250px':'1750px',height:bigWorldFloor == 1?'2500px':bigWorldFloor == 2?'1100px':bigWorldFloor == 7?'2250px':'1750px'}"
                alt=""
            />
        </div>

        <div class="component-content">
            <el-card>
                <div slot="header" class="clearfix">
                    <span>普通关卡数据</span>
                    <el-button-group>
                        <el-button
                            @click="generateData()"
                            v-clipboard:copy="lineup"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">生成最终数据
                        </el-button>
                        <el-button type="warning" @click="parseData()">解析数据</el-button>
                    </el-button-group>
                </div>
                <el-input type="textarea" v-model="lineup"></el-input>
            </el-card>


            <el-card>
                <div slot="header" class="clearfix">
                    <span>战力计算 </span>
                    <el-button @click="getCalcLineUp()">查询</el-button>
                    <el-button v-if="showLineupDetail" @click="showLineupDetail = false">
                        收起详情
                    </el-button>
                    <el-button v-else @click="showLineupDetail = true" type="success">
                        查看详情
                    </el-button>
                    <span>总战力 : {{ lineupNum }} =
                        怪兽总战力({{ monsterSum }}) + 神灵总战力({{ godLvSum }}) +
                        神灵契约总战力({{ contractLvSum }}) + 战墙总战力({{ wallSum }})
                    </span>
                </div>
                <el-form label-suffix=":" label-width="60px" v-if="showLineupDetail">
                    <el-collapse accordion>
                        <el-form-item :label="'怪兽'+ (monsterIdx + 1)" :key="monsterIdx"
                                      v-for="(item,monsterIdx) in monsterBattleEVOS">
                            <el-collapse-item v-if="item" :key="monsterIdx"
                                              :title="'最终结果（四舍五入）: (beSlotA * beSlotB + beSlotC) * beSlotD = '+ item.result"
                                              :name="index">
                                <el-form v-if="item">
                                    <el-form-item>
                                        <span>最终结果（四舍五入）: (beSlotA * beSlotB + beSlotC) * beSlotD = {{
                                                item.result
                                            }}</span>
                                    </el-form-item>
                                    <el-form-item>
                                        <span>beSlotA({{ item.beSlotA }}): 怪兽自身基础攻击({{ item.atk }}) * 攻速({{
                                                item.atkSpd
                                            }}) + 怪兽自身基础体力 ({{ item.con }})/ 3</span>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-row>
                                            <el-col>beSlotB({{ item.beSlotB }}): 1 +
                                                极化现有%总和({{ item.plrzPctSum }}) / 2 +
                                                性格系数({{ item.characterMlp }}) * 0.03
                                            </el-col>
                                        </el-row>
                                        <el-row class="battleE-col">
                                            <el-col>+ 稀有度星数({{ item.rarityStar }}) * 0.05 +
                                                世界回响%总和({{ item.resoundPctSum }}) / 2
                                            </el-col>
                                        </el-row>
                                        <el-row class="battleE-col">
                                            <el-col>+ (元核进阶次数({{ item.glyphAdv }}) + 5) *
                                                四字词条属性条数总和({{ item.entrySum4 }}) *
                                                四字词条属性品质均值({{ item.entryRA4 }}) * (1 +
                                                词条属性同调效果总和({{ item.entryHESum }})) * 词条属性系数({{ item.entryMlp }})
                                                * 0.01
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-row>
                                            <el-col>beSlotC({{ item.beSlotC }}):
                                                小基因突破次数({{ item.smallStrengthen }}) * 30 +
                                                大基因突破次数({{ item.bigStrengthen }}) * 120
                                            </el-col>
                                        </el-row>
                                        <el-row class="battleE-col">
                                            <el-col> + (元核等级({{ item.glyphLv }}) + 4) * 12 *
                                                词条属性系数({{ item.entryMlp }}) + (元核进阶次数({{ item.glyphAdv }}) + 5)
                                                * 两字词条属性条数总和({{ item.entrySum2 }}) *
                                                两字词条属性品质均值({{ item.entryRA2 }}) * (1 +
                                                词条属性同调效果总和({{ item.entryHESum }})) * 词条属性系数({{ item.entryMlp }})
                                                * 12
                                            </el-col>
                                        </el-row>
                                        <el-row class="battleE-col">
                                            <el-col> + 起源基石战力总和({{ item.ofsSum }}) +
                                                怪兽形态战力总和({{ item.skinSum }}) +
                                                黑暗森林无上限升级项总等级({{ item.dfUnlimitedLvSum }}) * 6 +
                                                世界回响战力总和({{ item.resoundSum }})
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item>

                                        <el-row>
                                            <el-col>beSlotD({{ item.beSlotD }}): 1 +
                                                技能等级总和({{ item.abilityLv }}) * 0.05 +
                                                (元核进阶次数({{ item.glyphAdv }}) + 5) *
                                                宿命效果品质系数({{ item.fateRarityMlp }}) * 宿命效果系数({{ item.fateMlp }})
                                                * 0.02
                                            </el-col>
                                        </el-row>
                                        <el-row class="battleE-col">
                                            <el-col>+ 黑暗森林有上限升级项总等级({{ item.dfLimitedLvSum }}) * 0.008 +
                                                极化能力品质总和({{ item.plrzARSum }}) * 0.01
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                </el-form>
                            </el-collapse-item>
                        </el-form-item>
                    </el-collapse>
                </el-form>
            </el-card>

            <el-card>
                <div slot="header" class="clearfix">
                    <span>关卡</span>
                    <el-button-group>
                        <el-button @click="addLevel()">添加子关卡</el-button>
                        <el-button type="danger" @click="deleteLevel()">删除子关卡</el-button>
                    </el-button-group>
                </div>

                <template v-for="(lv, lvIdx) in levels">
                    <el-button v-bind:key="lvIdx"
                               v-bind:class="{ 'el-button--success': lvIdx === currentLevelIdx }"
                               size="mini" @click="selectLevel(lvIdx)" plain>{{ getLevelName(lvIdx) }}
                    </el-button>
                </template>
            </el-card>

            <el-card>
                <div slot="header" class="clearfix">
                    <span>回合</span>
                    <el-button-group>
                        <el-button @click="addRound()">添加回合</el-button>
                        <el-button type="danger" @click="deleteRound()">删除回合</el-button>
                    </el-button-group>
                </div>
                <template v-for="(round, roundIdx) in levels[currentLevelIdx]">
                    <el-button v-bind:key="roundIdx"
                               v-bind:class="{ 'el-button--success': roundIdx === currentRoundIdx }"
                               size="mini" @click="selectRound(roundIdx)" plain>{{ roundIdx + 1 }}
                    </el-button>
                </template>
            </el-card>


            <el-card v-if="currentRound != null">
                <div slot="header" class="clearfix" >
                    <span>阵容数据</span>
                </div>
                <el-row>
                    <el-col :span="3" v-for="(editMonster, idx) in currentRound.monsters" :key="idx"
                            class="spacing">
                        <el-badge :value="idx + 1" type="info">
                            <div v-if="editMonster.identifier" @click="editMonsterFn(idx)">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/monster_icon/'+editMonster.identifier+'.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                            <!-- <el-button v-if="null != editMonster && editMonster.identifier" type="danger" icon="el-icon-delete" circle size="small" @click="deleteMonster(idx)"></el-button> -->
                            <el-button plain v-else @click="editMonsterFn(idx)">添加</el-button>
                            <el-button plain v-if="null != editMonster && editMonster.identifier"
                                       @click="deleteMonster(idx)" class="del-btn">删除
                            </el-button>
                        </el-badge>
                    </el-col>
                </el-row>

            </el-card>

            <el-dialog title='怪兽' :visible.sync="previewDateShow" width="80%" lock-scroll center>
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>怪兽</span>
                    </div>
                    <el-form class="edit-form" label-suffix=":" label-width="80px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="编号">
                                    <el-select v-model="editMonster.identifier" filterable placeholder='请选择'
                                               @change="handlerMonsterChange(editMonster)">
                                        <el-option v-for="item in monsterConfigs" :key="item.id"
                                                   :label="$t(item.name)"
                                                   :value="item.id">
                                            <el-image style="width: 30px; height: 30px; float: left"
                                                      :src="'./static/monster_icon/'+item.id+'.png'"
                                                      fit="cover"></el-image>
                                            <span style="float: right">{{ $t(item.name) }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="等级">
                                    <el-input-number v-model.number="editMonster.level" :min="0" :max="200000"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="性格">
                                    <el-select v-model="editMonster.temperamentId" placeholder='请选择'>
                                        <el-option v-for="item in monsterTemperamentConfigs" :key="item.id"
                                                   :label="$t(item.name)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="皮肤">
                                    <el-select v-model="editMonster.skinId">
                                        <el-option
                                            :key="sgt.id"
                                            v-for="(sgt,index) in skinGainType"
                                            :label="getSkinName(sgt)"
                                            :value="sgt.id"
                                            v-if="sgt.monster_identifier===editMonster.identifier || sgt.id === 0">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="技能等级">
                            <el-row>
                                <el-col :span="5" v-for="(lv, idx) in editMonster.abilityStarMap"
                                        v-if="currentMonsterConfig && idx <= (currentMonsterConfig.abilities.split(',')).length"
                                        :key="idx">
                                    <span v-if="idx < 9">技能{{ idx }}-等级:</span>
                                    <el-input-number v-model.number="editMonster.abilityStarMap[idx]"
                                                     class="number-spacing"
                                                     :key="idx" :min="1" :max="6"/>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>基因强化</span>
                    </div>
                    <el-form class="edit-form" label-width="70px" label-suffix=":">

                        <el-form-item label="条数">
                            <el-input-number v-model.number="editMonster.strengthenCount"
                                             @change="onStrengthenCountChange(editMonster)"
                                             :min="0"
                                             :max="1 + Math.floor((editMonster.level - 1) / 2) > monsterConfiguration[201].split('#').length ? monsterConfiguration[201].split('#').length : 1 + Math.floor((editMonster.level - 1) / 2)"/>
                            <span>(上限受等级影响)</span>
                        </el-form-item>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="小基因">
                                    <el-select v-model="oneClickGenSmall" placeholder='请选择'>
                                        <el-option v-for="item in strengthens"
                                                   :key="item.id" :label="getStrengthenName(item)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <el-button @click="oneClickGen('small',editMonster)">批量设置</el-button>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="大基因">
                                    <el-select v-model="oneClickGenBig" placeholder='请选择'>
                                        <el-option v-for="item in bigStrengthens"
                                                   :key="item.id" :label="getStrengthenName(item)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <el-button @click="oneClickGen('big',editMonster)">批量设置</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="配置">
                            <el-row>
                                <el-col :span="6" v-for="(str, idx) in editMonster.strengthenCount" :key="idx">
                                    <span v-if="idx < 9">基因编号- {{ idx + 1 }}:</span>
                                    <span v-if="idx >= 9">基因编号-{{ idx + 1 }}:</span>
                                    <el-select v-model="editMonster.strengthenList[idx]" placeholder='请选择'>
                                        <el-option
                                            v-for="item in (idx + 1) % parseInt(monsterConfiguration[202]) !== 0 ? strengthens : bigStrengthens"
                                            :key="item.id" :label="getStrengthenName(item)" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>

                </el-card>

                <el-card>
                    <div slot="header" class="clearfix">
                        <span>极化参数配置</span>
                    </div>

                    <el-form class="edit-form" label-width="100px" label-suffix=":">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="极化攻击力">
                                    <el-input-number v-model.number="editMonster.plrzAtk" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="极化体力">
                                    <el-input-number v-model.number="editMonster.plrzCon" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="极化霸气">
                                    <el-input-number v-model.number="editMonster.plrzHaki" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="极化移动速度">
                                    <el-input-number v-model.number="editMonster.plrzMspd" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="极化能力条数">
                            <el-input-number v-model="editMonster.editMonsterPlrzAbilitiesLen"
                                             @change="onPlrzCountChange(editMonster)"
                                             :min="0"
                                             :max="parseInt(plrzRange[plrzRange.length - 1].split('_')[0])"/>
                            <span>(选择相同能力会覆盖)</span>
                            <el-row>
                                <el-col :span="12" v-for="(ability,index) in editMonster.plrzAbilitiesMap"
                                        :key="index">
                                    <el-select v-model="ability.identifier" placeholder='请选择'>
                                        <el-option v-for="item in plrzAbilities"
                                                   :key="item.id" :label="$t(item.description)"
                                                   :value="item.id"
                                                   :disabled="handlePlrzAbility(item.id,editMonster.plrzAbilitiesMap)"
                                        >
                                        </el-option>
                                    </el-select>

                                    <span>品质：</span>
                                    <el-select v-model="ability.quality" placeholder='请选择'>
                                        <el-option v-for="item in plrzAbilityQuality" :key="item.id"
                                                   :label="$t(item.name)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>

                </el-card>

                <el-card v-if="editMonster.emblemIn">
                    <div slot="header" class="clearfix">
                        <span>其他 - 元核编辑</span>
                    </div>
                    <el-image v-if="editMonster.emblemIn.baseType > 0" style="width: 60px; height: 60px"
                              :src="'./static/glyph_icon/'+editMonster.emblemIn.quality+'_'+editMonster.emblemIn.baseType+'.png'"
                              fit="cover">
                    </el-image>
                    <el-button @click="editEmblemFn(currentMonsterIdx,'monster')">编辑元核</el-button>
                </el-card>

                <el-card>
                    <div slot="header" class="clearfix">
                        <span>其他 - 增减益设置</span>
                    </div>
                    <el-form label-suffix=":" label-width="100px" class="edit-form">
                        <el-form-item label="增减益条数">
                            <el-input-number v-model="editMonster.editMonsterBonusLen"
                                             @change="onBonusCountChange(editMonster)" :min="0"/>
                        </el-form-item>
                        <el-form-item label="增减益设置">
                            <el-row>
                                <template v-for="(bonus,index) in editMonster.bonus">
                                    <el-col :span="6" class="spacing" :key="index">
                                        <span>增减益- {{ index + 1 }}:</span>
                                        <el-select v-model="bonus.key" :key="index" placeholder='请选择'>
                                            <el-option v-for="item in bonuses" :key="item.value"
                                                       :label="item.name"
                                                       :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <span>系数:</span>
                                        <el-input-number :key="index" v-model.number="bonus.value"/>
                                    </el-col>
                                </template>
                            </el-row>
                        </el-form-item>
                    </el-form>

                </el-card>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDetailLog()">关闭编辑</el-button>
                </div>
            </el-dialog>

            <el-dialog title="元核" :visible.sync="previewEmblemDateShow" width="80%" lock-scroll center>
                <el-form class="edit-form">
                    <el-form-item label="主属性:">
                        <el-select v-model="editEmblem.baseType" placeholder='请选择'>
                            <el-option v-for="item in glyphType" :key="item.id"
                                       :label="$t(item.name)+'-'+$t(item.description)"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-form v-if="editEmblem.baseType !== '0'" label-width="60px">
                            <el-form-item label="品质:">
                                <el-select v-model="editEmblem.quality"
                                           @change="onGlyphEntriesCountChange(editEmblem)">
                                    <el-option v-for="item in plrzAbilityQuality" :key="item.id"
                                               :label="$t(item.name)"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="等级:">
                                <el-input-number v-model.number="editEmblem.level" :min="0"
                                                 :max="100"
                                                 @change="onGlyphLevelChange(editEmblem)"/>
                                <span>(进阶次数：{{ editEmblem.stage }})</span>
                            </el-form-item>
                            <el-form-item label="宿命:">
                                <el-select v-model="editEmblem.fateType" placeholder='请选择'
                                           @change="changeFateType(editEmblem)">
                                    <el-option v-for="item in glyphFateType" :key=" item.id"
                                               :label="$t(item.name)+'-'+$t(item.description)"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                                <span v-if="editEmblem.fateType > 0">浮动值:</span>
                                <el-input-number v-if="editEmblem.fateType > 0"
                                                 v-model.number="editEmblem.fateFloatingValue"
                                                 :step="0.0001" :precision="4"
                                                 :min="defaultEntryFloatingValueArr[editEmblem.quality - 1] - 0.05"
                                                 :max="defaultEntryFloatingValueArr[editEmblem.quality - 1] + 0.05"/>
                            </el-form-item>

                            <el-form-item label="词条数:">
                                <el-input-number v-model="editEmblem.editGlyphEntriesLen" :min="1"
                                                 :max="editEmblem.quality"
                                                 @change="glyphEntriesChange(editEmblem)"/>
                                <span>(上限受元核品质影响)</span>
                            </el-form-item>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="16"
                                            v-for="(entry,entryIdx) in editEmblem.entries"
                                            :key="entryIdx">
                                        <span>词条{{ entryIdx + 1 }}:</span>
                                        <el-select v-model="entry.type" placeholder='请选择' size="small">
                                            <!--                                            :label="$t(item.name) +'-'+($t(item.description))"-->
                                            <el-option v-for="item in glyphEntryType" :key="item.id"
                                                       :label="$t(item.name)"
                                                       :value="item.id">
                                                <span style="float: left">{{ $t(item.name) }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{ $t(item.description) }}</span>
                                            </el-option>
                                        </el-select>
                                        <span>词条品质{{ entryIdx + 1 }}:</span>
                                        <el-select v-model="entry.quality" placeholder="请选择"
                                                   @change="defaultEntryFloatingValue(entry)">
                                            <el-option v-for="item in plrzAbilityQuality" :key="item.id"
                                                       :label="$t(item.name)"
                                                       :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <span v-if="entry.quality">浮动值:</span>
                                        <el-input-number v-if="entry.quality"
                                                         v-model.number="entry.floatingValue"
                                                         :step="0.0001" :precision="4"
                                                         :min="defaultEntryFloatingValueArr[entry.quality - 1] - 0.05"
                                                         :max="defaultEntryFloatingValueArr[entry.quality - 1] + 0.05"/>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeEmblemDetailLog()">关闭编辑</el-button>
                </div>
            </el-dialog>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>神灵</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-form-item label="神灵">
                        <el-checkbox-group v-model="currentRound.godIds" :max="addGodLen"
                                           @change="godIdChange(currentRound.godIds)">
                            <el-checkbox v-for="item in godConfigs" :key="item.id" :label="item.id">
                                <el-image style="width: 35px; height: 50px; float: left"
                                          :src="'./static/god_battle_icon/god_battle_icon_'+ item.id +'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image style="width: 35px; height: 50px; float: left"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>
                                {{ $t(item.name) }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-row>
                        <el-col :span="8" v-for="(item,index) in currentRound.godIds" :key="item">
                            <el-form-item :label="$t(godConfigMap[item].name) +'阶'">

                                <el-input-number v-model.number="currentRound.editGodLv[item]" :min="0"
                                                 :max="12"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card v-if="currentRound && currentRound.godIds.length > 0 && editorAncientCampaign  === false">
                <div slot="header" class="clearfix">
                    <span>神灵释放序列</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-row>
                        <el-col :span="8" v-for="(item,index) in 5" :key="item">
                            <el-form-item :label="'第' + (index + 1) + '个'" :key="item"
                                          :hidden="currentRound.editGodCast.indexOf(-1)>-1&&currentRound.editGodCast.indexOf(-1) < index">
                                <el-select v-model="currentRound.editGodSeq[index]" placeholder='请选择'>
                                    <el-option v-for="item in godConfigs" :key="item.id"
                                               v-if="currentRound.godIds.indexOf(item.id) > -1"
                                               :label="$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>

                                <el-select v-model="currentRound.editGodCast[index]" placeholder='请选择'>
                                    <el-option v-for="item in godSequenceTime" :key="item.id" :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>世界回响等级</span>
                </div>
                <el-input-number v-model.number="currentRound.resoundLevel" :min="0"/>
            </el-card>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>神灵契约</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-form-item label="层数">
                        <el-input-number v-model="currentRound.editGodContractIdentifiersLen"
                                         @change="onContractCountChange"
                                         :min="0" :max="6"/>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12"
                                v-for="(identifier,stage) in currentRound.editGodContract.identifiers"
                                :key="stage">
                            <el-form-item :label="'第' + (stage +1) + '层'" :key="stage">
                                <el-select v-model="currentRound.editGodContract.identifiers[stage]"
                                           placeholder='请选择'>
                                    <template v-for="(config, idx)  in godContractConfig">
                                        <el-option v-if="idx >= (stage + 1) * 3 - 3 && idx < (stage + 1) * 3"
                                                   :key="config.id"
                                                   :label="$t(config.name) +'-'+ $t(config.description)"
                                                   :value="config.id">
                                        </el-option>
                                    </template>
                                </el-select>
                                <span>等级: </span>
                                <el-input-number v-model.number="currentRound.editGodContract.floorLv[stage]"
                                                 class="number-spacing" :key="stage" :min="0" :max="10"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>战墙增益</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-form-item label="加固次数">
                        <el-input-number v-model="currentRound.editWarWalls.reinforced" :min="0"/>
                    </el-form-item>

                    <el-form-item label="战墙方向">
                        <el-switch v-model="currentRound.isOwnWall" active-text="已方"
                                   inactive-text="敌方"></el-switch>
                    </el-form-item>
                    <el-form-item label="大战纹">
                        <el-checkbox-group v-model="currentRound.ownWallIds"
                                           v-if="currentRound.isOwnWall == true">
                            <el-checkbox v-for="item in wallGrooveConfig" :key="item.id" v-if="item.type == 1"
                                         :label="item.id">
                                {{ $t(item.name) }}
                            </el-checkbox>
                        </el-checkbox-group>
                        <el-checkbox-group v-model="currentRound.oppWallIds"
                                           v-if="currentRound.isOwnWall ==false">
                            <el-checkbox v-for="item in wallGrooveConfig" :key="item.id" v-if="item.type == 2"
                                         :label="item.id">
                                {{ $t(item.name) }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="普通战纹">
                        <el-input-number v-model="currentRound.normalWallCount" :min="0" :max="32"/>
                        <el-button @click="configNormal">配置普通战纹</el-button>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12" v-for="(mark,index) in currentRound.editWarWalls.marks" :key="index">
                            <el-form-item :key="index">
                                <span>战纹{{ index + 1 }}：</span>
                                <el-select v-model="mark.identifier" placeholder='请选择'>
                                    <el-option v-for="item in wallGrooveConfig" :key="item.id"
                                               :label="$t(item.name)"
                                               :value="item.id"
                                               v-if="currentRound.isOwnWall === true?(item.type == 3):(item.type == 4)">
                                    </el-option>
                                </el-select>
                                <span>品质：</span>
                                <el-select v-model="mark.quality" placeholder='请选择'>
                                    <el-option v-for="item in wallGainQuality" :key="item.id"
                                               :label="$t(item.val)"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>起源石增益</span>
                </div>

                <el-form class="edit-form">
                    <el-row>
                        <el-col :span="12" v-for="item in originFootingStoneConfig" :key="item.id">
                            <div>{{ $t(item.gain_base_desc) }}</div>
                            <el-form-item :key="item.id" :label="'增益提升 :'">
                                <el-input-number v-model.number="currentRound.ofsGain[item.id]" :min="1"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>黑暗森林增益</span>
                </div>
                <el-form class="edit-form" label-position="left" :inline="true" label-suffix=":">
                    <el-row>
                        <el-col :span="8" v-for="item in darkForestAbilityConfig" :key="item.id">
                            <div>{{ $t(item.name) }}</div>
                            <el-form-item :key="item.id" :label="$t(item.description)">
                                <blockquote v-if="item.max_lv == 0">
                                    <el-input-number v-model.number="currentRound.dfGain[item.id]" :min="0"/>
                                </blockquote>
                                <blockquote v-else>
                                    <el-input-number v-model.number="currentRound.dfGain[item.id]" :min="0"
                                                     :max="item.max_lv"/>
                                </blockquote>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </div>

        <el-card>
            <div slot="header" class="clearfix">
                <span>奖励串数据</span>
                <el-button-group>
                    <el-button
                        @click="generateRewardData()"
                        v-clipboard:copy="rewardStr"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">生成奖励串
                    </el-button>
                    <el-button type="warning" @click="parseRewardData(rewardStr)">解析奖励串</el-button>
                </el-button-group>
            </div>
            <el-input type="textarea" v-model="rewardStr"></el-input>
        </el-card>

        <el-card>
            <div slot="header" class="clearfix">
                <span>奖励组</span>
                <el-button-group>
                    <el-button @click="addRewardGroup()">添加奖励组</el-button>
                    <el-button type="danger" @click="deleteRewardGroup()">删除奖励组</el-button>
                </el-button-group>
            </div>

            <template v-for="(rdg, rdgIdx) in rewardGroups">
                <el-button :key="rdgIdx"
                           :class="{ 'el-button--success': rdgIdx === currentRewardGroupIdx }"
                           size="mini" @click="selectRewardGroup(rdgIdx)" plain>{{ rdgIdx + 1 }}
                </el-button>
            </template>
        </el-card>

        <el-card>
            <div slot="header" class="clearfix">
                <span>子奖励</span>
                <el-button-group>
                    <el-button @click="addReward()">添加子奖励</el-button>
                    <el-button type="danger" @click="deleteReward()">删除子奖励</el-button>
                </el-button-group>
            </div>
            <template v-for="(rd, rdIdx) in rewardGroups[currentRewardGroupIdx]">
                <el-button :key="rdIdx"
                           :class="{ 'el-button--success': rdIdx === currentRewardIdx }"
                           size="mini" @click="selectReward(rdIdx)" plain>{{ rdIdx + 1 }}
                </el-button>
            </template>
        </el-card>

        <el-card>
            <div slot="header" class="clearfix">
                <span>奖励串详情</span>
            </div>
            <div v-if="currentRewardGroupIdx!==null&&currentRewardIdx!==null">
                <div v-for="(item,index) in rewardGroups[currentRewardGroupIdx]" style="margin-bottom: 20px;">
                    {{item.length!==0?((index+1)+ ': ' + item):''}}
                    <span>{{item.length!==0?('('+ finalContentCNArr[index]+ ')'):''}}</span>
                </div>
            </div>
        </el-card>

        <component-main-reward :currentReward="currentReward" :currentRewardIdx="currentRewardIdx" @reward="getReward"></component-main-reward>
    </el-card>
</template>

<script>
    import confApi from '../../service/conf_api'
    import commonApi from '../../service/common_api'
    import actionConfirm from '../../mixins/action_confirm'
    import warGrooveQualityJson from '../../data/config/war_groove_quality.json'
    import godSequenceTimeJson from '../../data/config/god_sequence_time.json'
    import bounseJson from '../../data/config/bounse.json'
    import plrzAbilityQualityJson from '../../data/config/plrz_ability_quality.json'
    import {mapState} from 'vuex';
    import componentMainReward from '../../components/component_main_reward'

    export default {
        data() {
            return {
                plrzAbilityQuality: plrzAbilityQualityJson,
                wallGainQuality: warGrooveQualityJson,
                godSequenceTime: godSequenceTimeJson,
                bonuses: bounseJson,
                oneClickGenSmall: null,
                oneClickGenBig: null,
                addGodLen: 5,

                editorAncientCampaign: false,
                ancientCampaignLineup: {},

                //动态配置数据
                monsterConfigs: [],
                monsterTemperamentConfigs: [],
                wallGrooveConfig: [],
                wallGrooveConfigMap: {},
                darkForestAbilityConfig: [],
                originFootingStoneConfig: [],
                strengthens: [],
                bigStrengthens: [],
                godContractConfig: [],
                warWallConfiguration: {},
                godConfigs: [],
                godConfigMap: {},
                glyphType: [],
                glyphEntryType: [],
                glyphFateType: [],
                skinGainType: [],
                defaultEntryFloatingValueArr: [0.55, 0.65, 0.75, 0.85, 0.95, 1.05],
                showLineupDetail: false,
                monsterConfiguration: {
                    201: "",
                    202: "",
                },
                plrzRange: ["6"],
                maxPlrz: 0,
                minPlrz: 0,
                // [{回合}, ...], ...
                // 同1个关卡节点可能会有多个关卡，同1个关卡可能会有多回合
                levels: [],
                currentLevelIdx: null,
                currentRoundIdx: null,
                currentRound: null,
                lineup: "",
                previewDateShow: false,
                currentMonsterIdx: null,
                currentMonsterConfig: null,
                previewEmblemDateShow: false,
                emblemMode: 'monster',
                editMonster: {},

                currentEmblemIdx: null,
                editEmblem: {},

                // 阵容战力
                lineupNum: 0,
                monsterSum: 0,
                wallSum: 0,
                contractLvSum: 0,
                godLvSum: 0,
                monsterBattles: [],
                monsterBattleEVOS: [],

                pointImg: '',
                pointSize: 10, //点的大小
                serialNumber: 0,
                parseImgUrl: require('../../assets/icons/map1.jpg'),
                banMa: [],
                pointColor:'red',
                mapSelectId: '',
                mapData: [],
                mapShow: true,

                rewardGroups: [],
                currentRewardGroupIdx: null,
                currentRewardIdx: null,
                currentReward: null,
                rewardStr: '',

                finalContentCNArr:[],

                optionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                },
                optionValue: '0',
                count1: '',
                count2: '',
                countSwitch: false,
                rate: 0.1,
                value: '',
                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],

                // 大世界层数
                bigWorldFloor: 1,
                mapNodeList: [],
                bigWorldData: [
                    // {
                    //     label: '源初之地',
                    //     value: 1
                    // },
                    // {
                    //     label: '开拓之地',
                    //     value: 2
                    // },
                    // {
                    //     label: '舛误之地',
                    //     value: 3
                    // },
                    // {
                    //     label: '崩坠之地',
                    //     value: 4
                    // },
                    // {
                    //     label: '虚诞之地',
                    //     value: 5
                    // },
                ]
            }
        },
        mixins: [actionConfirm],
        mounted() {
            this.addRewardGroup();
            // this.initData();

            document.getElementById("map").oncontextmenu = e => {
                if (e && e.preventDefault) {
                    e.preventDefault();
                } else {
                    window.event.returnValue = false;
                }
                return false;
            };

            document.getElementById("map").onmousedown = e => {
                e = e || window.event;
                if (e.button !== 2 ) {
                    //判断是否右击
                    /*
                  event.screenX是屏幕左上角到鼠标当前位置的x轴距离;
                  event.clientX是浏览器左上角到鼠标当前位置的x轴距离;
                  event.offsetX是鼠标当前点击控件左上角到鼠标当前位置的x轴距离;
                  */
                    var x = (e.offsetX || e.layerX)*2;
                    var y = (e.offsetY || e.layerY)*2;
                    console.log(x, y);
                    var myImg = document.querySelector("#map");
                    var currWidth = myImg.clientWidth;
                    var currHeight = myImg.clientHeight;
                    var ProportionWidthInImg = x / currWidth;
                    var ProportionHeightInImg = y / currHeight;
                    var div = document.getElementById('marker');
                    if (div !== null) {
                        document.getElementById("mapDiv").removeChild(div);
                    }
                    this.createMarker(x, y, false);
                    this.getConfData(x,y);
                }
            };
        },
        created() {
            this.initData();
            this.getConfData(0,0);
            this.getReadData();
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        methods: {
            // 创建坐标
            createMarker(x, y, isScroll) {
                var div = document.createElement("div");
                div.className = "marker";
                div.id = "marker";
                y = y + document.getElementById("map").offsetTop - this.pointSize / 2;
                x = x + document.getElementById("map").offsetLeft - this.pointSize / 2;
                div.style.width = this.pointSize  + "px";
                div.style.height = this.pointSize  + "px";
                // div.style.backgroundColor = this.pointColor;
                // div.style.background = "url(" + this.pointImg + ") no-repeat";
                div.style.background = this.pointColor;
                div.style.position = "absolute";
                div.style.left = x/2 + "px";
                div.style.top = y/2 + "px";
                div.oncontextmenu = e => {
                    var id = e.target.id;
                    document.getElementById("mapDiv").removeChild(div);
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    } else {
                        window.event.returnValue = false;
                    }
                    return false;
                };
                document.getElementById("mapDiv").appendChild(div);

                if (isScroll) {
                    document.getElementById('mapDiv').scrollTo(x/2-500,y/2-400);
                }
            },

            getConfData(x,y) {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'map_node'
                }).then(res => {
                    this.mapData = res;
                    res.forEach(item => {
                        if (Math.abs(item.coordinate_x-x)<50 && Math.abs(item.coordinate_y-y)<50 && item.floor == this.bigWorldFloor) {
                            this.mapSelectId = item.id;
                            this.lineup = item.enemy_config;
                            this.rewardStr = item.first_output;
                            this.parseData();
                            this.parseRewardData(item.first_output);
                        }
                    })
                })
            },

            // 选择坐标
            getMapSelectId(data) {
                var id = data[2];
                this.bigWorldFloor = data[0];
                this.mapSelectId = id;

                var div = document.getElementById('marker');
                if (div !== null) {
                    document.getElementById("mapDiv").removeChild(div);
                }
                this.mapData.forEach(item => {
                    if (item.id == id) {
                        this.createMarker(item.coordinate_x,item.coordinate_y, true);
                        this.getConfData(item.coordinate_x,item.coordinate_y);
                    }
                })
            },

            /**
             * 初始化数据
             * 回调动态配置数据
             */
            initData() {
                let self = this;
                let tables = 'monster_config,monster_temperament_config,monster_configuration,' +
                    'parameter_strengthen,monster_polarity_config,' +
                    'emblem_effect_config,god_config,god_contract_config,' +
                    'origin_footing_stone_config,dark_forest_ability_config,' +
                    'war_groove_config,skin_config,war_wall_configuration';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = res.monster_config;
                    self.monsterTemperamentConfigs = res.monster_temperament_config;
                    self.strengthens = [];
                    self.bigStrengthens = [];
                    for (let sg of res.parameter_strengthen) {
                        if (sg.type === 1) {
                            self.strengthens.push(sg);
                        } else {
                            self.bigStrengthens.push(sg);
                        }
                    }
                    self.plrzAbilities = res.monster_polarity_config;
                    self.godConfigs = res.god_config;
                    self.godConfigMap = {};
                    res.god_config.forEach(function (item) {
                        self.godConfigMap[item.id] = item;
                    })

                    self.wallGrooveConfig = res.war_groove_config;
                    let wallGrooveConfigMap = {};
                    self.wallGrooveConfig.forEach(item => {
                        wallGrooveConfigMap[item.id] = item;
                    })
                    self.wallGrooveConfigMap = wallGrooveConfigMap;

                    self.darkForestAbilityConfig = res.dark_forest_ability_config;
                    self.godContractConfig = res.god_contract_config;
                    self.originFootingStoneConfig = res.origin_footing_stone_config;
                    self.warWallConfiguration = res.war_wall_configuration;
                    self.skinGainType = res.skin_config;
                    self.skinGainType.unshift({
                        id: 0
                    });
                    self.warWallConfiguration = {};
                    for (let wwc of res.war_wall_configuration) {
                        let id = wwc.id,
                            val = wwc.key_value;
                        self.warWallConfiguration[id] = val;
                    }


                    self.monsterConfiguration = {};
                    for (let mc of res.monster_configuration) {
                        let id = mc.id;
                        let val = mc.key_value;
                        self.monsterConfiguration[id] = val;
                        if (id === 701) {
                            let splitValArr = val.split(',');
                            self.minPlrz = parseFloat(splitValArr[0]);
                            self.maxPlrz = parseFloat(splitValArr[1]);
                        } else if (id === 702) {
                            self.plrzRange = val.split(',');
                        }
                    }

                    self.glyphType = [{
                        id: 0,
                        name: '无',
                        description: '无元核'
                    }];
                    self.glyphEntryType = [];
                    self.glyphFateType = [{
                        id: 0,
                        name: '无',
                        description: '无效果'
                    }];

                    res.emblem_effect_config.forEach(function (item) {
                        let type = item.type;
                        if (type == 0) {
                            self.glyphType.push(item);
                        } else if (type == 1 || type == 2) {
                            self.glyphEntryType.push(item);
                        } else {
                            self.glyphFateType.push(item);
                        }
                    });

                    this.addLevel();
                })
            },
            /**
             * 查询阵容战力
             */
            getCalcLineUp() {
                var data = this.currentRound;
                let lineupData = this.generateLineup(data);
                commonApi.lineupCalculator({
                    token: this.token,
                    lineupVO: lineupData
                }).then(res => {
                    this.lineupNum = res.total;
                    this.monsterBattles = res.monsterBattles;
                    this.monsterBattleEVOS = res.monsterBattleEVOS;
                    this.monsterSum = res.monsterSum;
                    this.wallSum = res.wallSum;
                    this.contractLvSum = res.contractLvSum;
                    this.godLvSum = res.godLvSum;
                })
            },

            /**
             * @param {Object} itemId
             * @param {Object} plrzAbilitiesMap
             */
            handlePlrzAbility(itemId, plrzAbilitiesMap) {
                let currentArr = [];
                for (let plrzItem of plrzAbilitiesMap) {
                    currentArr.push(plrzItem.identifier);
                }

                return currentArr.indexOf(itemId) > -1;
            },

            handlerMonsterChange(editMonster){
                this.handlerMonsterIdentifierSkin(editMonster);
                let abSize = this.currentMonsterConfig.abilities.split(",").length;
                let ab = {};
                for (let i = 0; i < abSize; i++) {
                    ab[i+1] = 1;
                }
                editMonster.abilityStarMap = ab;
            },
            /**
             *
             */
            handlerMonsterIdentifierSkin(editMonster) {
                if (editMonster === undefined || editMonster.skinId === undefined) {
                    return;
                }
                let oldType = 0;
                let currentTypeMap = {};
                if (editMonster.skinId > 0) {
                    for (let sgt of this.skinGainType) {
                        if (sgt.id === editMonster.skinId) {
                            oldType = sgt.type;
                        }
                        if (sgt.monster_identifier === editMonster.identifier) {
                            currentTypeMap[sgt.type] = sgt.id;
                        }
                    }

                    editMonster.skinId = 0;
                    if (currentTypeMap[oldType] !== undefined) {
                        editMonster.skinId = currentTypeMap[oldType];
                    }
                }

                for (let monsterConfigItem of this.monsterConfigs) {
                    if (monsterConfigItem.id === editMonster.identifier) {
                        this.currentMonsterConfig = monsterConfigItem;
                    }
                }


                return editMonster.skinId;
            },
            /**
             * 一键基因处理
             * @param {Object} genType
             * @param {Object} editMonster
             */
            oneClickGen(genType, editMonster) {
                let self = this;
                let rateConfig = parseInt(self.monsterConfiguration[202]);
                if ((genType === 'big' && self.oneClickGenBig == null)) {
                } else if ((genType === 'small' && self.oneClickGenSmall == null)) {
                } else {
                    if (editMonster.strengthenCount > 0) {
                        let newGenArr = [];
                        for (let idx = 0; idx < editMonster.strengthenCount; idx++) {
                            let smallFlag = (idx + 1) % rateConfig !== 0;
                            if (genType === 'small' && smallFlag) {
                                newGenArr.push(self.oneClickGenSmall);
                            } else if (genType === 'big' && !smallFlag) {

                                newGenArr.push(self.oneClickGenBig);
                            } else {
                                newGenArr.push(editMonster.strengthenList[idx]);
                            }
                        }

                        editMonster.strengthenList = newGenArr;
                    }
                }
            },
            /**
             * 元核宿命效果调整
             * @param {Object} emblemIn
             */
            changeFateType(emblemIn) {
                if (emblemIn.fateType && emblemIn.fateType !== 0 && emblemIn.quality > 0) {
                    emblemIn.fateFloatingValue = this.defaultEntryFloatingValueArr[emblemIn.quality - 1];
                } else {
                    emblemIn.fateFloatingValue = 0;
                }
            },

            /**
             *设置默认浮动值
             * @param {Object} entry
             */
            defaultEntryFloatingValue(entry) {
                entry.floatingValue = this.defaultEntryFloatingValueArr[entry.quality - 1];
            },

            /**
             * 元核对象初始化
             */
            initEmblem() {
                return {
                    level: 1,
                    stage: 0,
                    quality: 1,
                    identifier: 50001,
                    identified: true,
                    entries: [],
                    baseType: 0,
                    fateType: 0,
                    fateFloatingValue: 0.0,
                    editGlyphEntriesLen: 1
                };
            },
            /**
             * 怪兽对象初始化
             */
            initMonster() {
                let monsterInit = {
                    identifier: null,
                    temperamentId: 15,
                    level: 1,
                    strengthenCount: 0,
                    strengthenList: [],
                    abilityStarMap: {
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0,
                        5: 0
                    },
                    plrzAtk: 0,
                    plrzCon: 0,
                    plrzHaki: 0,
                    plrzMspd: 0,
                    plrzAbilitiesMap: [],
                    bonus: [],
                    skinId: 0,

                    //不保存的数据字段
                    editMonsterPlrzAbilitiesLen: 0,
                    editMonsterBonusLen: 0
                };
                if (!this.editorAncientCampaign) {
                    monsterInit.emblemIn = this.initEmblem();
                }
                return monsterInit;
            },
            /**
             * 怪兽编辑
             **/
            editMonsterFn(idx) {
                this.currentMonsterIdx = idx;
                this.editMonster = this.currentRound.monsters[idx];
                this.handlerMonsterIdentifierSkin(this.editMonster);
                this.previewDateShow = true;
            },
            /**
             * 关闭怪兽编辑框
             **/
            closeDetailLog() {
                this.currentRound.monsters[this.currentMonsterIdx] = this.editMonster;
                this.previewDateShow = false;
            },
            deleteMonster(idx) {
                this.currentRound.monsters.splice(idx, 1, this.initMonster());
            },

            editEmblemFn(idx, emblemMode) {
                if (emblemMode === 'emblem') {
                    this.currentEmblemIdx = idx;

                    this.editEmblem = this.currentRound.editEmblems[idx];
                } else {
                    let currentMonster = this.currentRound.monsters[this.currentMonsterIdx];
                    this.editEmblem = currentMonster.emblemIn;
                }

                this.previewEmblemDateShow = true;
                this.emblemMode = emblemMode;
            },
            deleteEmblem(idx) {
                this.currentRound.editEmblems.splice(idx, 1, this.initEmblem());
            },
            closeEmblemDetailLog() {
                if (this.emblemMode === 'emblem') {
                    this.currentRound.editEmblems[this.currentEmblemIdx] = this.editEmblem;
                } else {
                    let currentMonster = this.currentRound.monsters[this.currentMonsterIdx];
                    currentMonster.emblemIn = this.editEmblem;
                    //this.currentRound.monsters[this.currentMonsterIdx] = currentMonster;
                }

                this.previewEmblemDateShow = false;
            },


            /**
             * 添加子关卡
             */
            addLevel() {
                let levels = this.levels;
                levels.push([]);
                this.currentLevelIdx = levels.length - 1;
                this.addRound();
            },
            /**
             * 选择子关卡
             * @param idx 下标
             */
            selectLevel(idx) {
                this.currentLevelIdx = idx;
                this.selectRound(0);
            },
            /**
             * 获取子关卡名称，罗马数字
             * @param idx 下标
             * @returns {string} 关卡名称
             */
            getLevelName(idx) {
                let data = {
                    'ↈ': 100000,
                    'ↂↈ': 90000,
                    'ↇ': 50000,
                    'ↂↇ': 40000,
                    'ↂ': 10000,
                    'Ⅿↂ': 9000,
                    'ↁ': 5000,
                    'Ⅿↁ': 4000,
                    'Ⅿ': 1000,
                    'ⅭⅯ': 900,
                    'Ⅾ': 500,
                    'ⅭⅮ': 400,
                    'Ⅽ': 100,
                    'ⅩⅭ': 90,
                    'Ⅼ': 50,
                    'ⅩⅬ': 40,
                    'Ⅹ': 10,
                    'Ⅸ': 9,
                    'Ⅷ': 8,
                    'Ⅶ': 7,
                    'Ⅵ': 6,
                    'Ⅴ': 5,
                    'Ⅳ': 4,
                    'Ⅲ': 3,
                    'Ⅱ': 2,
                    'Ⅰ': 1
                };
                let num = idx + 1;
                let roman = '';
                for (let i in data) {
                    while (num >= data[i]) {
                        roman += i;
                        num -= data[i];
                    }
                }
                return roman;
            },
            onCopy(e) {
                this.$message({
                    type: 'success',
                    message: '已复制至系统粘贴板'
                });
            },
            onError(e) {
                this.$message({
                    type: 'error',
                    message: '复制失败,请手动复制'
                });
            },
            /**
             * 删除子关卡
             */
            deleteLevel() {
                let levels = this.levels;
                let len = levels.length;
                if (len > 1) {
                    let idx = this.currentLevelIdx;
                    levels.splice(idx, 1);
                    this.selectLevel(idx >= len - 1 ? len - 2 : idx);
                }
            },

            /**
             * 添加回合
             */
            addRound() {
                let self = this;
                let rounds = this.levels[this.currentLevelIdx];
                let lineup = {
                    gods: [],
                    monsters: [
                        self.initMonster(),
                        self.initMonster(),
                        self.initMonster(),
                        self.initMonster(),
                        self.initMonster()
                    ],

                    //战墙
                    normalWallCount: 0,
                    isOwnWall: true,
                    ownWallIds: [],
                    oppWallIds: [],
                    editWarWalls: {
                        reinforced: 0,
                        marks: []
                    },
                    resoundLevel: 0,

                    //黑暗森林
                    dfGain: [],

                    //起源基石
                    ofsGain: [],

                    //神灵契约
                    editGodContractIdentifiersLen: 0,
                    editGodContract: {
                        identifiers: [],
                        floorLv: [0, 0, 0, 0, 0, 0],
                    },

                    //神灵
                    godIds: [],
                    editGodLv: [],
                    editGodSeq: [],
                    editGodCast: [],
                    editEmblems: []
                };
                rounds.push(lineup);

                this.selectRound(rounds.length - 1);
            },
            /**
             * 选择回合
             * @param idx 下标
             */
            selectRound(idx) {
                this.currentRoundIdx = idx;
                this.currentRound = this.levels[this.currentLevelIdx][idx];
            },
            /**
             * 删除回合
             */
            deleteRound() {
                let rounds = this.levels[this.currentLevelIdx];
                let len = rounds.length;
                if (len > 1) {
                    let idx = this.currentRoundIdx;
                    rounds.splice(idx, 1);
                    this.selectRound(idx >= len - 1 ? len - 2 : idx);
                }
            },
            /**
             * 四舍五入，可指定要保留的小数位
             * @param number 数字
             * @param decimalPlaces 要保留的小数位，默认不保留
             * @returns {number} 四舍五入后的数字
             */
            round(number, decimalPlaces = 0) {
                return Math.round(number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
            },
            /**
             * 配置普通战纹
             *
             */
            configNormal() {
                let marks = [];
                for (let i = 0; i < this.currentRound.normalWallCount; i++) {
                    marks.push({
                        identifier: null,
                        quality: 0
                    });
                }
                this.currentRound.editWarWalls.marks = marks;
            },
            /**
             * 神灵契约
             * @param e
             */
            onContractCountChange(e) {
                let editGodContract = this.currentRound.editGodContract;
                let identifiers = editGodContract.identifiers;
                let sub = this.currentRound.editGodContractIdentifiersLen - identifiers.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        identifiers.push(3 * identifiers.length + 1);
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        identifiers.splice(identifiers.length - 1, 1);
                    }
                }
                for (let i = 0; i < 6; i++) {
                    if (i < this.currentRound.editGodContractIdentifiersLen) {
                        if (editGodContract.floorLv[i] < 1) {
                            editGodContract.floorLv[i] = 1;
                        }
                    } else {
                        editGodContract.floorLv[i] = 0;
                    }
                }
            },

            /**
             * 获取皮肤名
             */
            getSkinName(sgt) {
                if (sgt.id === 0) {
                    return '无';
                }
                let names = ['邪能', '魔法', '机械', '美食', '制服', '玩具', '大和', '黄金', '冰川', '熔岩', '龙', '源力',
                    '部落', '世界杯', '深海'
                ];
                return names[sgt.type];
            },
            /**
             * 获取强化名
             */
            getStrengthenName(item) {
                let des = this.$t(item.description);
                return des.replace('{p1}', item.p1).replace('{p2}', item.p2);
            },
            /**
             * 其他减益
             * @param {Object} editMonster 当前编辑的怪兽
             */
            onBonusCountChange(editMonster) {
                let bonus = editMonster.bonus;
                let sub = editMonster.editMonsterBonusLen - bonus.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        bonus.push({
                            key: 'atkConstant',
                            value: 0
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        bonus.splice(bonus.length - 1, 1);
                    }
                }
            },
            /**
             * 极化技能条处理
             * @param {Object} editMonster 当前编辑的怪兽
             */
            onPlrzCountChange(editMonster) {
                let plrzAbilities = editMonster.plrzAbilitiesMap;
                let sub = editMonster.editMonsterPlrzAbilitiesLen - plrzAbilities.length;
                if (editMonster.editMonsterPlrzAbilitiesLen > 0 && editMonster.editMonsterPlrzAbilitiesLen < 4) {
                    editMonster.editMonsterPlrzAbilitiesLen = sub < 0 ? 0 : 4;
                    sub = editMonster.editMonsterPlrzAbilitiesLen - plrzAbilities.length;
                }
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        plrzAbilities.push({
                            identifier: i + 1,
                            quality: 1
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        plrzAbilities.splice(plrzAbilities.length - 1, 1);
                    }
                }
            },
            /**
             * 基因强化处理
             * @param {Object} editMonster 当前编辑的怪兽
             */
            onStrengthenCountChange(editMonster) {
                let strengthenList = editMonster.strengthenList;
                let sub = editMonster.strengthenCount - strengthenList.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        let idx = strengthenList.length + 1;
                        if (idx % parseInt(this.monsterConfiguration[202]) === 0) {
                            strengthenList.push(this.bigStrengthens[0].id);
                        } else {
                            strengthenList.push(this.strengthens[0].id);
                        }
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        strengthenList.splice(strengthenList.length - 1, 1);
                    }
                }
            },

            /**
             * 神灵
             * */
            godIdChange(godIds) {
                godIds.forEach(godId => {
                    let lv = this.currentRound.editGodLv[godId];
                    if (lv === undefined) {
                        this.currentRound.editGodLv[godId] = 0;
                    }
                })
            },

            /**
             * 元核效果调整
             * @param {Object} editMonster 当前编辑的元核
             */
            onGlyphEntriesCountChange(editEmblem) {
                let entries = editEmblem.entries;
                editEmblem.editGlyphEntriesLen = editEmblem.quality;
                let sub = editEmblem.editGlyphEntriesLen - entries.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        entries.push({
                            type: 7,
                            floatingValue: 0
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        entries.splice(entries.length - 1, 1);
                    }
                }

                this.changeFateType(editEmblem);
            },
            /**
             * 词条数量变化相应的判断
             * @param {Object} editMonster 当前编辑的元核
             */
            glyphEntriesChange(editEmblem) {
                let entries = editEmblem.entries;
                let max = editEmblem.quality;
                if (editEmblem.editGlyphEntriesLen > max) {
                    editEmblem.editGlyphEntriesLen = max;
                }
                let sub = editEmblem.editGlyphEntriesLen - entries.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        entries.push({
                            type: 7,
                            floatingValue: 0
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        entries.splice(entries.length - 1, 1);
                    }
                }
            },
            /**
             * 计算进阶次数
             * @param {Object} editEmblem 当前编辑的元核
             */
            onGlyphLevelChange(editEmblem) {
                editEmblem.stage = Math.floor(editEmblem.level / 5);
            },
            calSynchronizeLv(entries) {
                console.log(entries);
                let synchronizeLevel = 0;

                if (entries.length < 3) {
                    return synchronizeLevel;
                }

                let blue = 0;
                let purple = 0;
                let orange = 0;
                let red = 0;

                for (let i = 0; i < entries.length; i++) {
                    let entry = entries[i];
                    let quality = entry.quality;
                    switch (quality) {
                        case 3:
                            blue++;
                            break;
                        case 4:
                            purple++;
                            break;
                        case 5:
                            orange++;
                            break;
                        case 6:
                            red++;
                            break;
                    }
                }

                if (blue + purple + orange + red >= 3) synchronizeLevel = 1;
                if (purple + orange + red >= 4) synchronizeLevel = 2;
                if (orange + red >= 5) synchronizeLevel = 3;
                if (red >= 6) synchronizeLevel = 4;

                return synchronizeLevel;
            },

            generateEmblem(sourceEmblemIn) {
                let baseType = sourceEmblemIn.baseType;
                if (baseType <= 0) {
                    return null;
                }
                let glyphType = this.glyphType;
                let glyphEntryType = this.glyphEntryType;
                let glyphFateType = this.glyphFateType;

                let  ratio;
                for (let config of glyphType) {
                    if (baseType === config.id) {
                        ratio = config.strengthen_coefficient;
                    }
                }
                let synchronizeLevel = 0;
                let identifier = 50001;
                let valEntries = sourceEmblemIn.entries;
                let valEntriesL = valEntries.length;
                let level = sourceEmblemIn.level;
                let stage = sourceEmblemIn.stage;
                if (valEntriesL >= 3) {
                    console.log("!");
                    synchronizeLevel = this.calSynchronizeLv(sourceEmblemIn.entries);
                }
                let properties = [{
                    type: 0,
                    effectId: baseType,
                    quality: sourceEmblemIn.quality,
                    rdFloat: 1.0
                }];
                for (let i = 0; i < valEntriesL; i++) {
                    let valEntry = valEntries[i];
                    let effectId = valEntry.type;
                    let quality = valEntry.quality;
                    let type, value, ratio;
                    for (let config of glyphEntryType) {
                        if (config.id === effectId) {
                            type = config.type;
                            value = config.base_value;
                            ratio = config.strengthen_coefficient;
                            break;
                        }
                    }
                    let fv = valEntry.floatingValue;
                    properties.push({
                        type: type,
                        effectId: effectId,
                        rdFloat: fv,
                        quality: quality
                    });
                }
                let emblemIn = {
                    level: level,
                    stage: stage,
                    quality: sourceEmblemIn.quality,
                    properties: properties,
                    identified: true,
                    identifier: identifier,
                    synchronizeLevel: synchronizeLevel
                };
                let fateType = sourceEmblemIn.fateType;
                if (fateType !== 0) {
                    let  ratio;
                    for (let config of glyphFateType) {
                        if (fateType === config.id) {
                            ratio = config.strengthen_coefficient;
                        }
                    }
                    let fv = sourceEmblemIn.fateFloatingValue;
                    properties.push({
                        type: 3,
                        effectId: fateType,
                        rdFloat: fv,
                        quality: sourceEmblemIn.quality
                    });
                }
                return emblemIn;
            },
            parseEmblem(sourceEmblem){
                let emblemTpl = this.initEmblem();
                let emblemIn = {};
                for (let emblemTplKey in emblemTpl) {
                    let sourceTpl = sourceEmblem[emblemTplKey];
                    if (sourceTpl != undefined){
                        emblemIn[emblemTplKey] = sourceTpl;
                    }else{
                        emblemIn[emblemTplKey] = emblemTpl[emblemTplKey];
                    }
                }

                let entries = [];
                let properties = sourceEmblem.properties;
                for (let property of properties) {
                    let type = property.type;
                    if (type == 0) {
                        emblemIn.baseType = property.effectId;
                    } else if (type == 3) {
                        emblemIn.fateType = property.effectId;
                        emblemIn.fateFloatingValue = property.rdFloat;
                    } else {
                        entries.push({
                            type: property.effectId,
                            quality: property.quality,
                            floatingValue: property.rdFloat
                        });
                    }
                }

                emblemIn.entries = entries;
                emblemIn.editGlyphEntriesLen = emblemIn.entries.length;
                return emblemIn;
            },
            /**
             * 生成单个阵容
             * @param {Object} round
             */
            generateLineup(round) {
                let lineup = {};
                let self = this;

                //怪兽处理
                let skinGains = [];
                let monsters = [];
                let appMonsters = round.monsters;
                for (let i = 0, l = appMonsters.length; i < l; i++) {
                    let appMonster = appMonsters[i];
                    if (null == appMonster.identifier) {
                        monsters.push(null);
                        continue;
                    }

                    let monster = appMonster == null ? null : {};
                    for (let key in appMonster) {
                        if (appMonster.hasOwnProperty(key)) {
                            let val = appMonster[key];
                            switch (key) {
                                case 'emblemIn':
                                    let newEmblemIn = self.generateEmblem(val);
                                    if (newEmblemIn != null) {
                                        monster[key] = newEmblemIn;
                                    }
                                    break;
                                case 'plrzAbilitiesMap':
                                    if (val.length) {
                                        monster[key] = {};
                                        for (let pa of val) {
                                            monster[key][pa.identifier] = pa.quality;
                                        }
                                    }
                                    break;
                                case 'bonus':
                                    let l = val.length;
                                    if (l) {
                                        let bonus = {};
                                        for (let i = 0; i < l; i++) {
                                            let b = val[i];
                                            let key = b.key;
                                            let value = b.value;
                                            if (bonus[key] === undefined) {
                                                bonus[key] = value;
                                            } else {
                                                bonus[key] += value;
                                            }
                                        }
                                        monster[key] = bonus;
                                    }
                                    break;
                                case 'skinId':
                                    if (val !== 0) {
                                        val = self.handlerMonsterIdentifierSkin(appMonster);
                                        skinGains.push(val);
                                    }
                                    monster[key] = val;
                                    break;
                                case 'editMonsterBonusLen':
                                case 'editMonsterPlrzAbilitiesLen':
                                    delete monster[key]
                                    break;
                                default:
                                    monster[key] = val;
                                    break;
                            }
                        }
                    }
                    monsters.push(monster);
                }

                //神灵处理
                let gods = [];
                let appGodIds = round.godIds;
                for (let i = 0, l = appGodIds.length; i < l; i++) {
                    let appGodId = appGodIds[i];
                    if (appGodId === null || appGodId === undefined) {
                        continue;
                    }
                    let god = {
                        identifier: appGodId,
                        level: round.editGodLv[appGodId]
                    }

                    gods.push(god);
                }

                lineup = {
                    gods: gods,
                    monsters: monsters
                };

                //神灵契约
                if (round.editGodContractIdentifiersLen > 0) {
                    lineup.godContract = {
                        identifiers: round.editGodContract.identifiers.join(),
                        floorLv: round.editGodContract.floorLv.join()
                    };
                }

                //释放序列
                let appGodSeq = round.editGodSeq
                let appGodCast = round.editGodCast
                if (appGodSeq.length > 0) {
                    let godSequence = [];

                    for (let i = 0, l = appGodSeq.length; i < l; i++) {
                        let appGodSeqItem = appGodSeq[i];
                        let appGodCastItem = appGodCast[i];
                        if (appGodSeqItem === null || appGodSeqItem === undefined) {
                            continue;
                        }
                        godSequence.push({
                            identifier: appGodSeqItem,
                            cast: appGodCastItem
                        })

                    }

                    lineup.godSequence = godSequence;
                }

                //起源基石
                if (round.ofsGain.length > 0) {
                    let ofsGains = [];
                    let appOfsGain = round.ofsGain;

                    for (let i = 0, l = appOfsGain.length; i < l; i++) {
                        let appOfsGainItem = appOfsGain[i];
                        if (appOfsGainItem == null) {
                            continue;
                        }

                        ofsGains.push({
                            identifier: i,
                            mlp: appOfsGainItem
                        })

                    }
                    lineup.ofsGains = ofsGains;
                }

                //黑暗森林
                if (round.dfGain.length > 0) {
                    let dfGains = [];
                    let appDfGain = round.dfGain;

                    for (let i = 0, l = appDfGain.length; i < l; i++) {
                        let appDfGainItem = appDfGain[i];
                        if (appDfGainItem == null) {
                            continue;
                        }

                        dfGains.push({
                            identifier: i,
                            level: appDfGainItem
                        })

                    }
                    lineup.dfGains = dfGains;
                }

                //皮肤
                if (skinGains.length) {
                    lineup.skinGains = skinGains;
                }

                //战墙
                let warWalls = {
                    reinforced: 0,
                    marks: []
                };
                let setWallFlag = false;
                if (round.editWarWalls) {
                    warWalls.reinforced = round.editWarWalls.reinforced;
                    setWallFlag = true;
                }
                if (round.normalWallCount > 0 ||
                    round.oppWallIds.length > 0 ||
                    round.ownWallIds.length > 0) {
                    setWallFlag = true;
                    let marks = [];

                    //大战纹
                    let wallIds;
                    if (round.isOwnWall) {
                        wallIds = round.ownWallIds;
                    } else {
                        wallIds = round.oppWallIds;
                    }

                    for (let i = 0, l = wallIds.length; i < l; i++) {
                        let wallId = wallIds[i];
                        if (wallId == null) {
                            continue;
                        }
                        marks.push({
                            identifier: wallId,
                            quality: 0
                        })
                    }

                    //小战纹
                    for (let i = 0, l = round.editWarWalls.marks.length; i < l; i++) {
                        let mark = round.editWarWalls.marks[i];
                        if (mark == null) {
                            continue;
                        }
                        marks.push(mark)
                    }
                    warWalls.marks = marks;
                }
                if (setWallFlag) {
                    lineup.warWalls = warWalls;
                }
                if (!round.resoundLevel) {
                    lineup.resoundLevel = 0;
                }
                return lineup;
            },

            parseLineup(round){
                let self = this;

                let monsters = round.monsters;
                let mons = [];
                //怪兽
                for (let monster of monsters) {
                    let mon;
                    let monsterTpl = this.initMonster();

                    if (monster === null) {
                        mon = self.initMonster();
                    } else {
                        mon = {};
                        for (let key in monsterTpl) {
                            if (monster[key] !== undefined) {
                                let val = monster[key];
                                switch (key) {
                                    case 'emblemIn':
                                        mon[key] = self.parseEmblem(val);
                                        break;
                                    case 'plrzAbilitiesMap':
                                        let abilities = [];
                                        for (let aKey in val) {
                                            abilities.push({
                                                identifier: parseInt(aKey),
                                                quality: parseInt(val[aKey])
                                            });
                                        }
                                        mon[key] = abilities;
                                        break;
                                    case 'bonus':
                                        let bonus = [];
                                        for (let bonusKey in val) {
                                            bonus.push({
                                                key: bonusKey,
                                                value: val[bonusKey]
                                            });
                                        }
                                        mon[key] = bonus;
                                        break;
                                    default:
                                        mon[key] = monster[key];
                                        break;
                                }
                            } else {
                                //let a = monsterTpl[key];

                                mon[key] = monsterTpl[key];
                            }
                        }
                    }
                    mon.editMonsterBonusLen = mon.bonus.length;
                    mon.editMonsterPlrzAbilitiesLen = mon.plrzAbilitiesMap.length;
                    mons.push(mon);
                }
                round.monsters = mons;

                //神灵
                let gods = round.gods;
                let godIds = [];
                let editGodLv = [];
                if (gods && gods.length > 0) {
                    gods.forEach(god => {
                        godIds.push(god.identifier);
                        editGodLv[god.identifier] = god.level;
                    })
                }
                round.godIds = godIds;
                round.editGodLv = editGodLv;


                //神灵释放序列
                let seq = round.godSequence
                let editGodSeq = [];
                let editGodCast = [];

                if (seq && seq.length > 0) {
                    for (let i = 0, l = seq.length; i < l; i++) {
                        let seqItem = seq[i];
                        if (seqItem === null || seqItem === undefined) {
                            continue;
                        }
                        editGodSeq.push(seqItem.identifier);
                        editGodCast.push(seqItem.cast);
                    }
                }
                round.editGodSeq = editGodSeq;
                round.editGodCast = editGodCast;


                //神灵契约
                let godContract = round.godContract;
                let editGodContract = {
                    identifiers: [],
                    floorLv: [0, 0, 0, 0, 0, 0]
                };
                editGodContract.identifiers = [];
                editGodContract.floorLv = [];
                if (godContract) {
                    godContract.identifiers.split(",").forEach(identifierItem => {
                        if (identifierItem !== null && identifierItem !== undefined) {
                            editGodContract.identifiers.push(identifierItem >> 0);
                        }

                    });


                    let seqFloorLvArr = godContract.floorLv.split(",");

                    for (let i = 0, l = seqFloorLvArr.length; i < l; i++) {
                        let itemFloorLv = seqFloorLvArr[i];
                        if (itemFloorLv !== null && itemFloorLv !== undefined) {
                            editGodContract.floorLv[i] = itemFloorLv >> 0;
                        }
                    }
                }

                round.editGodContract = editGodContract;
                round.editGodContractIdentifiersLen = editGodContract.identifiers.length;

                //黑暗森林
                let dfGains = round.dfGains;
                let dfGain = [];
                if (dfGains && dfGains.length > 0) {
                    for (let i = 0, l = dfGains.length; i < l; i++) {
                        let dfGainsItem = dfGains[i];
                        let ofsIdentifier = dfGainsItem.identifier >> 0;
                        let ofsLv = dfGainsItem.level >> 0;
                        dfGain[ofsIdentifier] = ofsLv;
                    }
                }
                round.dfGain = dfGain;

                //战墙
                let warWalls = round.warWalls;
                let normalWallCount = 0;
                let isOwnWall = true;
                let ownWallIds = [];
                let oppWallIds = [];
                let editWarWalls = {
                    reinforced: 0,
                    marks: []
                };

                if (warWalls) {
                    editWarWalls.reinforced = warWalls.reinforced >> 0;
                    let marks = [];
                    for (let i = 0, l = warWalls.marks.length; i < l; i++) {
                        let mark = warWalls.marks[i];
                        let markIdentifier = mark.identifier >> 0;
                        let markQuality = mark.quality >> 0;
                        let warGrooveConfig = warGrooveMap[markIdentifier];
                        let warGrooveConfigType = warGrooveConfig.type;
                        if (warGrooveConfigType == 1) {
                            ownWallIds.push(markIdentifier);
                        } else if (warGrooveConfigType == 2) {
                            isOwnWall = false;
                            oppWallIds.push(markIdentifier);
                        } else {
                            normalWallCount++;
                            marks.push({
                                identifier: markIdentifier,
                                quality: markQuality
                            });
                        }
                    }
                    editWarWalls.marks = marks;
                }

                round.normalWallCount = normalWallCount;
                round.isOwnWall = isOwnWall;
                round.ownWallIds = ownWallIds;
                round.oppWallIds = oppWallIds;
                round.editWarWalls = editWarWalls;


                //起源基石
                let ofsGains = round.ofsGains;
                let ofsGain = [];
                if (ofsGains && ofsGains.length > 0) {
                    for (let i = 0, l = ofsGains.length; i < l; i++) {
                        let ofsGainItem = ofsGains[i];
                        ofsGain[ofsGainItem.identifier] = ofsGainItem.mlp;
                    }
                }
                round.ofsGain = ofsGain;
                console.log("resoundLevel", round.resoundLevel)
                if (round.resoundLevel === undefined) {
                    round.resoundLevel = 0;
                }

                if (round.editEmblems !== undefined) {
                    let newEmblems = [];
                    round.editEmblems.forEach(editEmblem=>{
                        newEmblems.push(self.parseEmblem(editEmblem));
                    })
                    round.editEmblems = newEmblems;
                }

                return round;
            },

            /**
             * 生成json数据
             */
            generateData() {
                let self = this;
                let result = {
                    levels: []
                };
                this.levels.forEach(rounds => {
                    let lvs = [];
                    rounds.forEach(round => {
                        let lineup = self.generateLineup(round);
                        lvs.push(lineup);
                    })
                    result.levels.push(lvs);
                })
                result.count = result.levels.length;
                this.lineup = JSON.stringify(result);
                this.getCalcLineUp();
            },


            /**
             * 解析json数据
             */
            parseData() {
                let self = this;
                if ("" === this.lineup.trim()) {
                    this.$message({
                        type: 'error',
                        message: '阵容没有数据'
                    });
                    return;
                }
                let lineup = JSON.parse(this.lineup);
                let levels = lineup.levels;
                let warGrooveMap = this.wallGrooveConfigMap;
                levels.forEach(rounds => {
                    rounds.forEach(round => {
                        self.parseLineup(round);
                    })
                })

                this.levels = levels;
                if (levels.length) {
                    this.selectRound(0);
                    this.getCalcLineUp();
                }
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }
            },

            getReward(mainReward, idx, finalContentCN) {
                this.currentRewardIdx = idx;
                this.rewardGroups[this.currentRewardGroupIdx][idx] = mainReward;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][idx];

                this.finalContentCNArr[idx] = finalContentCN;
            },

            addRewardGroup() {
                let rewardGroups = this.rewardGroups;
                rewardGroups.push([]);
                this.currentRewardGroupIdx = rewardGroups.length - 1;
                this.addReward();
            },

            deleteRewardGroup() {
                let rewardGroups = this.rewardGroups;
                let len = rewardGroups.length;
                if (len > 1) {
                    let idx = this.currentRewardGroupIdx;
                    rewardGroups.splice(idx, 1);
                    this.selectRewardGroup(idx >= len - 1 ? len - 2 : idx);
                }
            },

            selectRewardGroup(idx) {
                this.currentRewardGroupIdx = idx;
                this.selectReward(0);

                this.rewardGroups[this.currentRewardGroupIdx].forEach((item,index) => {
                    this.resolveRewardStr(item);

                    let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                    this.finalContentCNArr[index] = finalContentCN;
                })
            },

            selectReward(idx) {
                this.currentRewardIdx = idx;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][idx];
            },

            addReward() {
                let rewards = this.rewardGroups[this.currentRewardGroupIdx];
                rewards.push([]);
                this.selectReward(rewards.length - 1);
            },

            deleteReward() {
                let rewards = this.rewardGroups[this.currentRewardGroupIdx];
                let len = rewards.length;
                if (len > 1) {
                    let idx = this.currentRewardIdx;
                    rewards.splice(idx, 1);
                    this.finalContentCNArr.splice(idx, 1);
                    this.selectReward(idx >= len - 1 ? len - 2 : idx);
                }
            },
            resolveRewardStr(str) {
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry: [3, 0],
                            quality: 0,
                            active: true
                        },
                        {
                            entry: [3, 0],
                            quality: 0,
                            active: false
                        },
                        {
                            entry: [3, 0],
                            quality: 0,
                            active: false
                        },
                        {
                            entry: [3, 0],
                            quality: 0,
                            active: false
                        },
                        {
                            entry: [3, 0],
                            quality: 0,
                            active: false
                        },
                        {
                            entry: [3, 0],
                            quality: 0,
                            active: false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if (countArry.length > 1) {
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length > 1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            } else {
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length > 1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if (fateArray.length > 1) {
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id: parseInt(item[0]), chance: parseInt(item[1])}
                                }
                            } else {
                                if (element > 0) {
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                } else {
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element * 100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0] && entryArray[index].split('@').length > 1) {
                                            self.editEmblemEntries[index].entry = [item.value, iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length - 1].split('|');
                            if (countAndEntry.length > 1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            parseRewardData(data) {
                var arr = [];
                data = data.split(';');

                data.forEach(item => {
                    arr.push(item.split(','))
                })
                this.rewardGroups = arr;
                this.currentRewardGroupIdx = 0;
                this.currentRewardIdx = 0;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][this.currentRewardIdx];

                this.rewardGroups[this.currentRewardGroupIdx].forEach((item,index) => {
                    this.resolveRewardStr(item);

                    let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                    this.finalContentCNArr[index] = finalContentCN;
                })
            },

            generateRewardData() {
                var data = this.rewardGroups;
                for (var i=0;i<data.length;i++) {
                    for (var j=0;j<data[i].length;j++) {
                        if (data[i][j].length<=0) {
                            data[i].splice(j,1);
                            j = j-1;
                        }
                    }
                    if (data[i].length<=0) {
                        data.splice(i,1);
                        i = i-1;
                    }
                }

                data.forEach(item => {
                    item = item.join(',')
                })

                data = data.join(';');
                this.rewardStr = data;
            },

            getReadData() {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'map_node'
                }).then(res => {
                    this.mapNodeList = res;
                    let bigWorldData = [];
                    let mapChildren1 = [];
                    let mapChildren2 = [];
                    let mapChildren3 = [];
                    let mapChildren4 = [];
                    let mapChildren5 = [];
                    let mapChildren6 = [];
                    let mapChildren7 = [];
                    let mapChildren8 = [];
                    let typeChildren1 = [];
                    let typeChildren2 = [];
                    let typeChildren3 = [];
                    let typeChildren4 = [];
                    let typeChildren5 = [];
                    let typeChildren6 = [];
                    let typeChildren7 = [];
                    let typeChildren8 = [];
                    let typeChildren9 = [];
                    let typeChildren10 = [];
                    let typeChildren21 = [];
                    let typeChildren22 = [];
                    let typeChildren23 = [];
                    let typeChildren24 = [];
                    let typeChildren25 = [];
                    let typeChildren26 = [];
                    let typeChildren27 = [];
                    let typeChildren28 = [];
                    let typeChildren29 = [];
                    let typeChildren210 = [];
                    let typeChildren31 = [];
                    let typeChildren32 = [];
                    let typeChildren33 = [];
                    let typeChildren34 = [];
                    let typeChildren35 = [];
                    let typeChildren36 = [];
                    let typeChildren37 = [];
                    let typeChildren38 = [];
                    let typeChildren39 = [];
                    let typeChildren310 = [];
                    let typeChildren41 = [];
                    let typeChildren42 = [];
                    let typeChildren43 = [];
                    let typeChildren44 = [];
                    let typeChildren45 = [];
                    let typeChildren46 = [];
                    let typeChildren47 = [];
                    let typeChildren48 = [];
                    let typeChildren49 = [];
                    let typeChildren410 = [];
                    let typeChildren51 = [];
                    let typeChildren52 = [];
                    let typeChildren53 = [];
                    let typeChildren54 = [];
                    let typeChildren55 = [];
                    let typeChildren56 = [];
                    let typeChildren57 = [];
                    let typeChildren58 = [];
                    let typeChildren59 = [];
                    let typeChildren510 = [];
                    let typeChildren61 = [];
                    let typeChildren62 = [];
                    let typeChildren63 = [];
                    let typeChildren64 = [];
                    let typeChildren65 = [];
                    let typeChildren66 = [];
                    let typeChildren67 = [];
                    let typeChildren68 = [];
                    let typeChildren69 = [];
                    let typeChildren610 = [];
                    let typeChildren71 = [];
                    let typeChildren72 = [];
                    let typeChildren73 = [];
                    let typeChildren74 = [];
                    let typeChildren75 = [];
                    let typeChildren76 = [];
                    let typeChildren77 = [];
                    let typeChildren78 = [];
                    let typeChildren79 = [];
                    let typeChildren710 = [];
                    let typeChildren81 = [];
                    let typeChildren82 = [];
                    let typeChildren83 = [];
                    let typeChildren84 = [];
                    let typeChildren85 = [];
                    let typeChildren86 = [];
                    let typeChildren87 = [];
                    let typeChildren88 = [];
                    let typeChildren89 = [];
                    let typeChildren810 = [];

                    mapChildren1 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren1
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren2
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren3
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren4
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren5
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren6
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren7
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren8
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren9
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren10
                        }
                    ];

                    mapChildren2 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren21
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren22
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren23
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren24
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren25
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren26
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren27
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren28
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren29
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren210
                        }
                    ];

                    mapChildren3 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren31
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren32
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren33
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren34
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren35
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren36
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren37
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren38
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren39
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren310
                        }
                    ];

                    mapChildren4 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren41
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren42
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren43
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren44
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren45
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren46
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren47
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren48
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren49
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren410
                        }
                    ];

                    mapChildren5 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren51
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren52
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren53
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren54
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren55
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren56
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren57
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren58
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren59
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren510
                        }
                    ];

                    mapChildren6 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren61
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren62
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren63
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren64
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren65
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren66
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren67
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren68
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren69
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren610
                        }
                    ];

                    mapChildren7 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren71
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren72
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren73
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren74
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren75
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren76
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren77
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren78
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren79
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren710
                        }
                    ];

                    mapChildren8 = [
                        {
                            label: 1,
                            value: 1,
                            children: typeChildren81
                        },
                        {
                            label: 2,
                            value: 2,
                            children: typeChildren82
                        },
                        {
                            label: 3,
                            value: 3,
                            children: typeChildren83
                        },
                        {
                            label: 4,
                            value: 4,
                            children: typeChildren84
                        },
                        {
                            label: 5,
                            value: 5,
                            children: typeChildren85
                        },
                        {
                            label: 6,
                            value: 6,
                            children: typeChildren86
                        },
                        {
                            label: 7,
                            value: 7,
                            children: typeChildren87
                        },
                        {
                            label: 8,
                            value: 8,
                            children: typeChildren88
                        },
                        {
                            label: 9,
                            value: 9,
                            children: typeChildren89
                        },
                        {
                            label: 10,
                            value: 10,
                            children: typeChildren810
                        }
                    ];


                    bigWorldData = [
                        {
                            label: '源初之地',
                            value: 1,
                            children: mapChildren1
                        },
                        {
                            label: '开拓之地',
                            value: 2,
                            children: mapChildren2
                        },
                        {
                            label: '舛误之地',
                            value: 3,
                            children: mapChildren3
                        },
                        {
                            label: '崩坠之地',
                            value: 4,
                            children: mapChildren4
                        },
                        {
                            label: '诡潮之地',
                            value: 5,
                            children: mapChildren5
                        },
                        {
                            label: 'XX之地',
                            value: 6,
                            children: mapChildren6
                        },
                        {
                            label: '七层之地',
                            value: 7,
                            children: mapChildren7
                        },
                        {
                            label: '八层之地',
                            value: 8,
                            children: mapChildren8
                        },
                    ]

                    for(var i=0;i<=this.mapNodeList.length-1;i++) {
                        let item = this.mapNodeList[i];
                        item.label = (item.id) +'-' + this.$t(item.name);
                        item.value = item.id
                        if (item.floor == 1) {
                            if (item.type == 1) {
                                typeChildren1.push(item);
                            } else if (item.type == 2) {
                                typeChildren2.push(item);
                            } else if (item.type == 3) {
                                typeChildren3.push(item);
                            } else if (item.type == 4) {
                                typeChildren4.push(item);
                            } else if (item.type == 5) {
                                typeChildren5.push(item);
                            } else if (item.type == 6) {
                                typeChildren6.push(item);
                            } else if (item.type == 7) {
                                typeChildren7.push(item);
                            } else if (item.type == 8) {
                                typeChildren8.push(item);
                            } else if (item.type == 9) {
                                typeChildren9.push(item);
                            } else if (item.type == 10) {
                                typeChildren10.push(item);
                            }

                        } else if (item.floor == 2) {
                            if (item.type == 1) {
                                typeChildren21.push(item);
                            } else if (item.type == 2) {
                                typeChildren22.push(item);
                            } else if (item.type == 3) {
                                typeChildren23.push(item);
                            } else if (item.type == 4) {
                                typeChildren24.push(item);
                            } else if (item.type == 5) {
                                typeChildren25.push(item);
                            } else if (item.type == 6) {
                                typeChildren26.push(item);
                            } else if (item.type == 7) {
                                typeChildren27.push(item);
                            } else if (item.type == 8) {
                                typeChildren28.push(item);
                            } else if (item.type == 9) {
                                typeChildren29.push(item);
                            } else if (item.type == 10) {
                                typeChildren210.push(item);
                            }
                        } else if (item.floor == 3) {
                            if (item.type == 1) {
                                typeChildren31.push(item);
                            } else if (item.type == 2) {
                                typeChildren32.push(item);
                            } else if (item.type == 3) {
                                typeChildren33.push(item);
                            } else if (item.type == 4) {
                                typeChildren34.push(item);
                            } else if (item.type == 5) {
                                typeChildren35.push(item);
                            } else if (item.type == 6) {
                                typeChildren36.push(item);
                            } else if (item.type == 7) {
                                typeChildren37.push(item);
                            } else if (item.type == 8) {
                                typeChildren38.push(item);
                            } else if (item.type == 9) {
                                typeChildren39.push(item);
                            } else if (item.type == 10) {
                                typeChildren310.push(item);
                            }
                        } else if (item.floor == 4) {
                            if (item.type == 1) {
                                typeChildren41.push(item);
                            } else if (item.type == 2) {
                                typeChildren42.push(item);
                            } else if (item.type == 3) {
                                typeChildren43.push(item);
                            } else if (item.type == 4) {
                                typeChildren44.push(item);
                            } else if (item.type == 5) {
                                typeChildren45.push(item);
                            } else if (item.type == 6) {
                                typeChildren46.push(item);
                            } else if (item.type == 7) {
                                typeChildren47.push(item);
                            } else if (item.type == 8) {
                                typeChildren48.push(item);
                            } else if (item.type == 9) {
                                typeChildren49.push(item);
                            } else if (item.type == 10) {
                                typeChildren410.push(item);
                            }
                        } else if (item.floor == 5) {
                            if (item.type == 1) {
                                typeChildren51.push(item);
                            } else if (item.type == 2) {
                                typeChildren52.push(item);
                            } else if (item.type == 3) {
                                typeChildren53.push(item);
                            } else if (item.type == 4) {
                                typeChildren54.push(item);
                            } else if (item.type == 5) {
                                typeChildren55.push(item);
                            } else if (item.type == 6) {
                                typeChildren56.push(item);
                            } else if (item.type == 7) {
                                typeChildren57.push(item);
                            } else if (item.type == 8) {
                                typeChildren58.push(item);
                            } else if (item.type == 9) {
                                typeChildren59.push(item);
                            } else if (item.type == 10) {
                                typeChildren510.push(item);
                            }
                        } else if (item.floor == 6) {
                            if (item.type == 1) {
                                typeChildren61.push(item);
                            } else if (item.type == 2) {
                                typeChildren62.push(item);
                            } else if (item.type == 3) {
                                typeChildren63.push(item);
                            } else if (item.type == 4) {
                                typeChildren64.push(item);
                            } else if (item.type == 5) {
                                typeChildren65.push(item);
                            } else if (item.type == 6) {
                                typeChildren66.push(item);
                            } else if (item.type == 7) {
                                typeChildren67.push(item);
                            } else if (item.type == 8) {
                                typeChildren68.push(item);
                            } else if (item.type == 9) {
                                typeChildren69.push(item);
                            } else if (item.type == 10) {
                                typeChildren610.push(item);
                            }
                        } else if (item.floor == 7) {
                            if (item.type == 1) {
                                typeChildren71.push(item);
                            } else if (item.type == 2) {
                                typeChildren72.push(item);
                            } else if (item.type == 3) {
                                typeChildren73.push(item);
                            } else if (item.type == 4) {
                                typeChildren74.push(item);
                            } else if (item.type == 5) {
                                typeChildren75.push(item);
                            } else if (item.type == 6) {
                                typeChildren76.push(item);
                            } else if (item.type == 7) {
                                typeChildren77.push(item);
                            } else if (item.type == 8) {
                                typeChildren78.push(item);
                            } else if (item.type == 9) {
                                typeChildren79.push(item);
                            } else if (item.type == 10) {
                                typeChildren710.push(item);
                            }
                        } else if (item.floor == 8) {
                            if (item.type == 1) {
                                typeChildren81.push(item);
                            } else if (item.type == 2) {
                                typeChildren82.push(item);
                            } else if (item.type == 3) {
                                typeChildren83.push(item);
                            } else if (item.type == 4) {
                                typeChildren84.push(item);
                            } else if (item.type == 5) {
                                typeChildren85.push(item);
                            } else if (item.type == 6) {
                                typeChildren86.push(item);
                            } else if (item.type == 7) {
                                typeChildren87.push(item);
                            } else if (item.type == 8) {
                                typeChildren88.push(item);
                            } else if (item.type == 9) {
                                typeChildren89.push(item);
                            } else if (item.type == 10) {
                                typeChildren810.push(item);
                            }
                        }
                    }
                    this.bigWorldData = bigWorldData;
                })
            },
        },
        components: {
            componentMainReward
        }
    };
</script>

<style lang="less">
    .box-card {

        .tip {
            margin: 10px 0;
            color: red;
            font-weight: bold;
            font-size: 12px;
            font-style: italic;
        }

        .spacing {
            margin-bottom: 5px;
        }

        .number-spacing {
            margin-bottom: 10px;
        }

        .circle-spacing {
            margin: 10px 0;
        }

        .edit-form {
            padding: 5px 10px;
            background-color: #f4f4f5;
            margin-bottom: 10px;
            border: 1px solid #d3d4d6;
            border-radius: 3px;
        }

        .del-btn {
            display: block;
        }

        .battleE-col {
            margin-left: 80px;
        }
    }


    #mapDiv{
        width: 100%;
        height: 800px;

        position:relative;
        img{
            display:inline-block;
            z-index: 1;
        }
        .marker{
            position:absolute;
            border-radius: 50%;
            z-index: 999;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/map_barrier/map_editor.vue